const EXT_POR_TIPO = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/heic': 'heic', 'image/heif': 'heif' };
const EXTS_OK = ['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif'];

export const isImagemValida = (file) => {
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  return EXTS_OK.includes(ext) || (file.type || '').startsWith('image/');
};

const comExtensao = (file) => {
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  if (EXTS_OK.includes(ext)) return file;
  const novaExt = EXT_POR_TIPO[file.type] || 'jpg';
  return new File([file], `foto.${novaExt}`, { type: file.type || 'image/jpeg' });
};

// Reduz a foto no celular antes do envio (máx 1600px, JPEG). Se falhar, devolve a original.
export const compressImage = (file, maxSize = 1600, quality = 0.8) => new Promise((resolve) => {
  if (!(file.type || '').startsWith('image/') || file.size < 800 * 1024) { resolve(comExtensao(file)); return; }
  const url = URL.createObjectURL(file);
  const img = new Image();
  const fallback = () => { URL.revokeObjectURL(url); resolve(comExtensao(file)); };
  img.onload = () => {
    try {
      const ratio = Math.min(1, maxSize / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(url);
        if (!blob) { resolve(comExtensao(file)); return; }
        resolve(new File([blob], (file.name.replace(/\.\w+$/, '') || 'foto') + '.jpg', { type: 'image/jpeg' }));
      }, 'image/jpeg', quality);
    } catch { fallback(); }
  };
  img.onerror = fallback;
  img.src = url;
});

export const mensagemErroApi = (err, fallback = 'Erro ao publicar') => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail?.message) return detail.message;
  if (!err?.response) return 'Falha de conexão. Verifique sua internet e tente novamente.';
  const status = err.response.status;
  if (status === 413) return 'Imagem muito grande. Tente uma foto menor.';
  if (status === 401) return 'Sua sessão expirou. Faça login novamente.';
  if (status >= 500) return `${fallback}: o servidor não respondeu (código ${status}). Tente novamente em instantes.`;
  return `${fallback} (código ${status}).`;
};
